<template lang="pug">
.features.address-info.sr-info.download-info
  .columns.first-info-container
    .column
      .feature-helvetica.top-feature.top-feature-margin.title-desc
        span.title.text-white-on-dark Earning made 
        span.title.pink easy 
        span.title.text-white-on-dark  with your PC.

      .feature-helvetica.top-feature
        span.subtitle Our app utilizes well known mining software under the hood and presents an easy to understand user interface for beginners and new miners!

      .feature-helvetica.bottom-feature.mt-20.download-files
        a.button.sr-link.download-mfi(:href='current.files[0].url', :download='current.files[0].name')
          .here.fw-400
            span Win 10 / 11 x64  
            i.fa.fa-windows
          b unMiner 
          i.fa.fa-download
          span.size-current.mfi - {{ current.files[0].size }}MB
          .here.fw-400 Latest version

      .feature-helvetica.bottom-feature.mt-30
        span If you are a more experienced miner you may want to try  
        router-link.info-link(to="/wizard")  
          span our easy configuration wizard 🧙‍♂️ for third party mining apps
          i.fa.fa-external-link.ml-5

    .column.is-flex.aic.jcc
      div.feature.img-miner-container
        Slider(:slides="7", :externalDots="true")
          img.img-miner.slide(:src="'/img/desktop-app/1-' + mode + '.png?v2'")
          img.img-miner.slide(:src="'/img/desktop-app/2-' + mode + '.png?v2'")
          img.img-miner.slide(:src="'/img/desktop-app/3-' + mode + '.png?v2'")
          img.img-miner.slide(:src="'/img/desktop-app/4-' + mode + '.png?v2'")
          img.img-miner.slide(:src="'/img/desktop-app/5-' + mode + '.png?v2'")
          img.img-miner.slide(:src="'/img/desktop-app/6-' + mode + '.png?v2'")
          img.img-miner.slide(:src="'/img/desktop-app/7-' + mode + '.png?v2'")

  .feature.feature-helvetica.has-text-left
    .tile.is-ancestor
      .tile.is-parent(v-for="o in tiles")
        article.tile.is-child.box
          p.title.is-spaced {{ o.title }}
          p.subtitle {{ o.subtitle }}


  .feature.feature-helvetica.has-text-left
    hr
    .columns.changelog-issues-column
      .column
        .feature-helvetica.fs-16.has-text-left.mb-10
          b Changelog
        ul
          li(v-for="o in changelog", :class="{'changelog-current': o.current}")
            .changelog-version 
              span {{ o.version }} - {{ o.buildDate }}  
              b(v-if="o.current") (Current)
            ul.changelog-detail-list
              li(v-for="p in o.changeList") 
                template(v-if="p.indexOf('IMPORTANT') > -1")
                  strong {{ p }}
                template(v-else) 
                  span {{ p }}
            a.button.sr-link.is-default.changelog-download-version(
              v-for="f in o.files"
              :href="f.url", 
              :download="f.name"
            )
              .here.fw-400
                b.fs-13.ml-4(v-if="f.type === 'Base'") Base 
                b.fs-13.ml-4(v-else) unMiner 
                span {{ f.osDetail }} 
                i.fa.fa-download
                span.size-current.main - {{ f.size }}MB
      .column
        .feature-helvetica.fs-16.has-text-left.mb-18
          b Having issues when installing / downloading?   

        .articles
          a.article-mini(href="https://unmineable.com/support/article/how-to-download-the-app-on-google-chrome", target="_blank")
            .article-inner
              .article-title
                span  Downloading the app on Google Chrome
              span.icon
                i.fa.fa-external-link
          a.article-mini(href="https://unmineable.com/support/article/how-to-allow-the-download-on-windows", target="_blank")
            .article-inner
              .article-title
                span My download is missing on Windows explorer
              span.icon
                i.fa.fa-external-link
          a.article-mini(href="https://unmineable.com/support/article/how-to-make-an-exclusion-on-windows-defender", target="_blank")
            .article-inner
              .article-title
                span Making an exclusion on Windows Defender / Security
              span.icon
                i.fa.fa-external-link


  .feature.feature-helvetica.has-text-left
    hr

  .feature.feature-helvetica.has-text-left

    hr
    p.smaller-content (*) 
      b.w400 A "Base Version" is provided for miners having issues when downloading (due to browser or antivirus restrictions). You will need to download and point your app to the third party miner files after the installation.
    p.smaller-content (*) 
      b.w400 For transparency, all of the software code can be audited through the option "Source" inside "About & Support"
    p.smaller-content (*) unMiner is only intended to be used with our pools.
    p.smaller-content (*) unMiner mostly recommended for new miners / beginners, as it doesn't provide enough customability for fine tuning and most functionality is hidden for simplicity. Advanced users should directly download any third party mining software of their preference that support our algorithms and use a custom setup / configuration.

</template>

<script>
import Slider from '../components/c_slider'
export default {
  name: 'view_download_miner',
  components: {
    Slider
  },
  data() {
    return {
      tiles: [
        {
          title: 'Built for everyone',
          subtitle: 'Created with beginners in mind, easy steps are provided for a straight forward experience.'
        },
        {
          title: 'Hardware Auto-detection',
          subtitle: 'No more searching for the correct mining algorithm, just let the app do the whole work (literally).'
        },
        {
          title: 'Unattended running',
          subtitle: 'With support for Minimize to System Tray and Run on System Login we got all your needs covered.'
        }
      ],
      changelog: [
        {
          version: '2.8.0-beta',
          versionNumber: '2.8.0',
          buildDate: '2025-03-10',
          changeList: [
            'Removed Miner-Files-Included version',
            'Added "Save my address" feature',
            'New Mining Files Manager feature',
            'New Downloader feature for obtaining missing mining executables',
            'Improved Auto hardware and algorithm detection, now running right before you first start mining',
            'Auto-start on system login now launches the app minimized to the system tray',
            'Bug Fixes',
            'IMPORTANT: If you are upgrading from a previous version, you will be prompted to re-download all third-party mining files. This can be easily done via the Mining Files, Downloader option.'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMiner.2.8.0-beta.exe',
              name: 'unMiner.2.8.0-beta.exe',
              type: 'Main',
              osDetail: 'Win 10 / 11 x64',
              size: 53.57
            }
          ],
          current: true
        },
        {
          version: '2.7.4-beta',
          versionNumber: '2.7.4',
          buildDate: '2024-12-27',
          changeList: [
            'Dropped PyrinHashV2 support',
            'Dropped EthashB3 support',
            'Dropped KHeavyHash support (removed LolMiner 1.76)',
            'LolMiner updated from 1.89 to 1.92 on the MFI version (Miner Files Included), supporting Octopus',
            'SRBMiner-Multi updated from v2.6.4 to v2.7.3 on the MFI version',
            'XMRIG updated from 6.21.3 to 6.22.2 on the MFI version',
            'OneZeroMiner updated from 1.3.5 to 1.4.3 on the MFI version'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMiner.2.7.4-beta-mfi.exe',
              name: 'unMiner.2.7.4-beta-mfi.exe',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 110.3
            },
            {
              url: 'https://cdn.unmineable.download/unMiner.2.7.4-beta-base.exe',
              name: 'unMiner.2.7.4-beta-base.exe',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 53.55
            }
          ]
        },
        {
          version: '2.7.3-beta',
          versionNumber: '2.7.3',
          buildDate: '2024-09-12',
          changeList: [
            'Added PyrinHashV2 support',
            'Dropped PyrinHash Lolminer support',
            'LolMiner updated from 1.88 to 1.89 on the MFI version (Miner Files Included), supporting KARLSENV2'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMiner.2.7.3-beta-mfi.exe',
              name: 'unMiner.2.7.3-beta-mfi.exe',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 127.84
            },
            {
              url: 'https://cdn.unmineable.download/unMiner.2.7.3-beta-base.exe',
              name: 'unMiner.2.7.3-beta-base.exe',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 53.55
            }
          ]
        },
        {
          version: '2.7.2-beta',
          versionNumber: '2.7.2',
          buildDate: '2024-09-12',
          changeList: [
            'Added KarlsenHashV2 support',
            'SRBMiner-Multi updated from v2.5.8 to v2.6.4 on the MFI version, supporting KarlsenHashV2'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMiner.2.7.2-beta-mfi.exe',
              name: 'unMiner.2.7.2-beta-mfi.exe',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 127.84
            },
            {
              url: 'https://cdn.unmineable.download/unMiner.2.7.2-beta-base.exe',
              name: 'unMiner.2.7.2-beta-base.exe',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 53.55
            }
          ]
        },
        {
          version: '2.7.1-beta',
          versionNumber: '2.7.1',
          buildDate: '2024-07-11',
          changeList: [
            'Added XelisHashV2 support',
            'OneZeroMiner updated from 1.3.4 to 1.3.5 on the MFI (Miner Files Included) version',
            'SRBMiner-Multi updated from v2.5.7 to v2.5.8 on the MFI version, supporting XelisHashV2 via CPU mining'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMiner.2.7.1-beta-mfi.exe',
              name: 'unMiner.2.7.1-beta-mfi.exe',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 126.25
            },
            {
              url: 'https://cdn.unmineable.download/unMiner.2.7.1-beta-base.exe',
              name: 'unMiner.2.7.1-beta-base.exe',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 53.55
            }
          ]
        },
        {
          version: '2.7.0-beta',
          versionNumber: '2.7.0',
          buildDate: '2024-06-20',
          changeList: [
            'Added Ghostrider support',
            'Added XelisHash support',
            'LolMiner updated from 1.85 Beta to 1.88 on the MFI (Miner Files Included) version',
            'SRBMiner-Multi updated from v2.5.0 to v2.5.7 on the MFI version',
            'XMRIG updated from 6.21.0 to 6.21.3 on the MFI version',
            'Improved new version / update available notification',
            'Fixed hash rate values in some algorithms'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMiner.2.7.0-beta-mfi.exe',
              name: 'unMiner.2.7.0-beta-mfi.exe',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 127.98
            },
            {
              url: 'https://cdn.unmineable.download/unMiner.2.7.0-beta-base.exe',
              name: 'unMiner.2.7.0-beta-base.exe',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 53.55
            }
          ]
        },
        {
          version: '2.6.0-beta',
          versionNumber: '2.6.0',
          buildDate: '2024-04-02',
          changeList: [
            'Added FishHash support',
            'LolMiner updated from 1.84 to 1.85 Beta on the MFI (Miner Files Included) version',
            'SRBMiner-Multi updated from v2.4.7 to v2.5.0 on the MFI version',
            'Dropped support for IronFish (Blake3) algorithm pools in favor of FishHash'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMiner.2.6.0-beta-mfi.exe',
              name: 'unMiner.2.6.0-beta-mfi.exe',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 126.56
            },
            {
              url: 'https://cdn.unmineable.download/unMiner.2.6.0-beta-base.exe',
              name: 'unMiner.2.6.0-beta-base.exe',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 53.89
            }
          ]
        },
        {
          version: '2.5.0-beta',
          versionNumber: '2.5.0',
          buildDate: '2024-02-22',
          changeList: [
            'Added Sha512256d support',
            'LolMiner updated from 1.82a to 1.84 on the MFI (Miner Files Included) version',
            'Added LolMiner 1.67 back to support stable KheavyHash mining',
            'SRBMiner-Multi updated from v2.4.4 to v2.4.7 on the MFI version',
            'XMRIG updated from 1.19.2 to 1.21.0 on the MFI version',
            'Dropped support for T-rex as it is not longer actively developed',
            'Temporarily removed support for the Octopus algorithm'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMiner.2.5.0-beta-mfi.exe',
              name: 'unMiner.2.5.0-beta-mfi.exe',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 126.96
            },
            {
              url: 'https://cdn.unmineable.download/unMiner.2.5.0-beta-base.exe',
              name: 'unMiner.2.5.0-beta-base.exe',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 53.5
            }
          ]
        },
        {
          version: '2.4.0-beta',
          versionNumber: '2.4.0',
          buildDate: '2024-01-15',
          changeList: [
            'Added SRBMiner-Multi 2.4.4',
            'Added PyrinHash support',
            'Added EthashB3 support',
            'LolMiner updated from 1.80a to 1.82a on the MFI version',
            'NBminer has been removed as it is not longer actively developed'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMiner.2.4.0-beta-mfi.exe',
              name: 'unMiner.2.4.0-beta-mfi.exe',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 152.1
            },
            {
              url: 'https://cdn.unmineable.download/unMiner.2.4.0-beta-base.exe',
              name: 'unMiner.2.4.0-beta-base.exe',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 50.5
            }
          ]
        },
        {
          version: '2.3.0-beta',
          versionNumber: '2.3.0',
          buildDate: '2024-01-02',
          changeList: [
            'Added OneZeroMiner 1.2.8',
            'Added DynexSolve algorithm support',
            'Automatically restart mining process on error or crash'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMiner.2.3.0-beta-mfi.exe',
              name: 'unMiner.2.3.0-beta-mfi.exe',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 122.3
            },
            {
              url: 'https://cdn.unmineable.download/unMiner.2.3.0-beta-base.exe',
              name: 'unMiner.2.3.0-beta-base.exe',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 50.5
            }
          ]
        },
        {
          version: '2.2.0-beta',
          versionNumber: '2.2.0',
          buildDate: '2023-12-11',
          changeList: [
            'Added KarlsenHash support',
            'Added KLS addresses support',
            'LolMiner updated from 1.76 to 1.80a on the MFI version'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMiner.2.2.0-beta-mfi.exe',
              name: 'unMiner.2.2.0-beta-mfi.exe',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 103.8
            },
            {
              url: 'https://cdn.unmineable.download/unMiner.2.2.0-beta-base.exe',
              name: 'unMiner.2.2.0-beta-base.exe',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 50.5
            }
          ]
        },
        {
          version: '2.1.1-beta',
          versionNumber: '2.1.1',
          buildDate: '2023-10-31',
          changeList: [
            'Added Nexa addresses support'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMiner.2.1.1-beta-mfi.exe',
              name: 'unMiner.2.1.1-beta-mfi.exe',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 103.2
            },
            {
              url: 'https://cdn.unmineable.download/unMiner.2.1.1-beta-base.exe',
              name: 'unMiner.2.1.1-beta-base.exe',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 50.5
            }
          ]
        },
        {
          version: '2.1.0-beta',
          versionNumber: '2.1.0',
          buildDate: '2023-10-06',
          changeList: [
            'Added Nexapow support',
            'PhoenixMiner has been removed as it is no longer actively developed'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMiner.2.1.0-beta-mfi.exe',
              name: 'unMiner.2.1.0-beta-mfi.exe',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 103.2
            },
            {
              url: 'https://cdn.unmineable.download/unMiner.2.1.0-beta-base.exe',
              name: 'unMiner.2.1.0-beta-base.exe',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 50.5
            }
          ]
        },
        {
          version: '2.0.2-beta',
          versionNumber: '2.0.2',
          buildDate: '2023-09-20',
          changeList: [
            'Fixed a bug with the version verification',
            'Improved some parameters for low power mode mining'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMiner.2.0.2-beta-mfi.exe',
              name: 'unMiner.2.0.2-beta-mfi.exe',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 107
            },
            {
              url: 'https://cdn.unmineable.download/unMiner.2.0.2-beta-base.exe',
              name: 'unMiner.2.0.2-beta-base.exe',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 50.5
            }
          ]
        },
        {
          version: '2.0.1-beta',
          versionNumber: '2.0.1',
          buildDate: '2023-09-05',
          changeList: [
            'Minor bug fixes and UI improvements'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMiner.2.0.1-beta-mfi.exe',
              name: 'unMiner.2.0.1-beta-mfi.exe',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 107
            },
            {
              url: 'https://cdn.unmineable.download/unMiner.2.0.1-beta-base.exe',
              name: 'unMiner.2.0.1-beta-base.exe',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 50.5
            }
          ]
        },
        {
          version: '2.0.0-beta',
          versionNumber: '2.0.0',
          buildDate: '2023-08-29',
          changeList: [
            'App renamed to unMiner 🙂',
            'Our most user-friendly update yet!',
            'Auto hardware detection to determine the optimal mining executable.',
            'Automatically detect if the mining process halts, so you can promptly address the issue.',
            'Support for all of our GPU and CPU algorithms.',
            'Rewritten from scratch to improve both loading speed and overall stability.',
            'More personalization options and settings for advanced users.',
            'Added an alternative connection option to prevent potential ISP restrictions.',
            'Added lots of validations to avoid settings / config issues.',
            'Minor bug fixes and more!'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMiner.2.0.0-beta-mfi.exe',
              name: 'unMiner.2.0.0-beta-mfi.exe',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 106.2
            },
            {
              url: 'https://cdn.unmineable.download/unMiner.2.0.0-beta-base.exe',
              name: 'unMiner.2.0.0-beta-base.exe',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 49.4
            }
          ]
        },
        {
          version: '1.7.2-beta',
          versionNumber: '1.7.2',
          buildDate: '2023-05-31',
          changeList: [
            'Added Octopus support',
            'Added IronFish support',
            'Added Blake3 support',
            'XMRIG updated from 6.18.0 to 6.19.2 on the MFI version',
            'LolMiner updated from 1.61 to 1.76 on the MFI version'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.7.2-beta-mfi.zip',
              name: 'unMineable_Miner_1.7.2-beta-mfi.zip',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 104.3
            },
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.7.2-beta-main.zip',
              name: 'unMineable_Miner_1.7.2-beta.zip',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 49.3
            }
          ]
        },
        {
          version: '1.7.1-beta',
          versionNumber: '1.7.1',
          buildDate: '2023-03-30',
          changeList: [
            'Added Kaspa addresses support'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.7.1-beta-mfi.zip',
              name: 'unMineable_Miner_1.7.1-beta-mfi.zip',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 104.3
            },
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.7.1-beta-main.zip',
              name: 'unMineable_Miner_1.7.1-beta.zip',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 49.3
            }
          ]
        },
        {
          version: '1.7.0-beta',
          versionNumber: '1.7.0',
          buildDate: '2022-11-15',
          changeList: [
            'Added KHeavyHash support',
            'Added ZHash support',
            'T-Rex miner 0.26.8 added as an option (FiroPow, Kawpow, Autolykos, Ethash and Etchash algorithms are supported)',
            'Added Firopow support',
            'Bug fixes'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.7.0-beta-mfi.zip',
              name: 'unMineable_Miner_1.7.0-beta-mfi.zip',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 104.3
            },
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.7.0-beta-main.zip',
              name: 'unMineable_Miner_1.7.0-beta.zip',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 49.3
            }
          ]
        },
        {
          version: '1.6.0-beta',
          versionNumber: '1.6.0',
          buildDate: '2022-10-20',
          changeList: [
            'LolMiner 1.61 added as an option (BeamHashIII, Zelhash, Autolykos, Ethash and Etchash algorithms are supported)',
            'Added ZelHash support',
            'Added BeamHashIII support',
            'PhoenixMiner updated from 5.9d to 6.2c on the MFI version',
            'NBminer updated from 42.2 to 42.3 on the MFI version',
            'XMRIG updated from 6.17 to 6.18 on the MFI version',
            'Added SSL ports to all of our supported algorithms',
            'Bug fixes'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.6.0-beta-mfi.zip',
              name: 'unMineable_Miner_1.6.0-beta-mfi.zip',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 72.5
            },
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.6.0-beta-main.zip',
              name: 'unMineable_Miner_1.6.0-beta.zip',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 49.3
            }
          ]
        },
        {
          version: '1.5.0-beta',
          buildDate: '2022-09-27',
          changeList: [
            'Added Ethash support back (via ETHW mining)'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.5.0-beta-mfi.zip',
              name: 'unMineable_Miner_1.5.0-beta-mfi.zip',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 66.1
            },
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.5.0-beta-main.zip',
              name: 'unMineable_Miner_1.5.0-beta.zip',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 49.3
            }
          ]
        },
        {
          version: '1.4.0-beta',
          buildDate: '2022-09-13',
          changeList: [
            'Dropped Ethash support'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.4.0-beta-mfi.zip',
              name: 'unMineable_Miner_1.4.0-beta-mfi.zip',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 66.1
            },
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.4.0-beta-main.zip',
              name: 'unMineable_Miner_1.4.0-beta.zip',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 49.3
            }
          ]
        },
        {
          version: '1.3.0-beta',
          buildDate: '2022-06-27',
          changeList: [
            'Autolykos support',
            'Bug fixes'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.3.0-beta-mfi.zip',
              name: 'unMineable_Miner_1.3.0-beta-mfi.zip',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 66.1
            },
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.3.0-beta-main.zip',
              name: 'unMineable_Miner_1.3.0-beta.zip',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 49.3
            }
          ]
        },
        {
          version: '1.2.2-beta',
          buildDate: '2022-05-27',
          changeList: [
            'NBminer updated from 42.1 to 42.2 on the MFI version.'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.2.2-beta-mfi.zip',
              name: 'unMineable_Miner_1.2.2-beta-mfi.zip',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 66.1
            },
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.2.2-beta-main.zip',
              name: 'unMineable_Miner_1.2.2-beta.zip',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 49.3
            }
          ]
        },
        {
          version: '1.2.1-beta',
          buildDate: '2022-05-26',
          changeList: [
            'Fix: Memo value was incorrectly set as required for some coins.'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.2.1-beta-mfi.zip',
              name: 'unMineable_Miner_1.2.1-beta-mfi.zip',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 66.1
            },
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.2.1-beta-main.zip',
              name: 'unMineable_Miner_1.2.1-beta.zip',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 49.3
            }
          ]
        },
        {
          version: '1.2.0-beta',
          buildDate: '2022-05-26',
          changeList: [
            'Multi chain support',
            'NBMiner added as an option (Kawpow, Ethash and Etchash algorithms are supported)',
            'Better memory RAM management (Logs are automatically cleared, mining processes won\'t hang any more)',
            'Working balance auto update (new websocket event)',
            'Updated miner files (on the MFI version): PhoenixMiner 5.9d, NBMiner 42.1, XMRIG 6.17.0.',
            'New installation wizard with automatic desktop shortcut',
            'More information on the mining screen',
            'Added minimize button',
            'Added pool port selection on advanced settings',
            'Minor visual bug fixes'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.2.0-beta-mfi.zip',
              name: 'unMineable_Miner_1.2.0-beta-mfi.zip',
              type: 'MFI',
              osDetail: 'Win 10 / 11 x64',
              size: 66.1
            },
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.2.0-beta-main.zip',
              name: 'unMineable_Miner_1.2.0-beta.zip',
              type: 'Base',
              osDetail: 'Win 10 / 11 x64',
              size: 49.3
            }
          ]
        },
        {
          version: '1.1.0-beta',
          buildDate: '2021-05-08',
          changeList: [
            'Launched separated MFI and main versions',
            'Added websocket support for real time stats'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.1.0-beta-mfi.zip',
              name: 'unMineable_Miner_1.1.0-beta-mfi.zip',
              type: 'MFI',
              osDetail: 'Win 10 x64',
              size: 49.3
            },
            {
              url: 'https://cdn.unmineable.download/unMineable.Miner.1.1.0-beta-main.zip',
              name: 'unMineable_Miner_1.1.0-beta.zip',
              type: 'Main',
              osDetail: 'Win 10 x64',
              size: 49.7
            }
          ]
        },
        {
          version: '1.0.1-beta',
          buildDate: '2020-12-12',
          changeList: [
            'Initial app launch'
          ],
          files: [
            {
              url: 'https://cdn.unmineable.download/unMineable Miner 1.0.1-beta-unpacked.zip',
              name: 'unMineable_Miner_1.0.1-unpacked.zip',
              type: 'Main',
              osDetail: 'Win 10 x64',
              size: 51.0
            }
          ]
        }
      ]
    }
  },
  computed: {
    current() {
      let vm = this
      let current = vm.changelog.find(element => element.current)
      return current
    },
    mode() {
      return this.$store.getters.mode
    },
    coin() {
      return this.$store.getters.coin
    }
  },
  created() {
    let vm = this
    vm.updateMetaTags()
    vm.$store.dispatch('setPageSelected', 'miner')
    vm.$store.dispatch('validateVersion')
  },
  methods: {
    updateMetaTags() {
      let vm = this
      let coin = vm.coin || localStorage.getItem('coin')
      let title = `unMiner - Earning ${coin} made easy with your PC. Your crypto mining companion!`
      if (!coin) title = `unMiner - Earning made easy with your PC. Your crypto mining companion!`
      document.title = title
      const metaTitle = document.querySelector('head meta[property="og:title"]');
      metaTitle.setAttribute('content', title);
    }
  }
}
</script>

<style lang="stylus" scoped>

.first-info-container
  margin-bottom: 48px;

.address-info
  max-width 1080px

.top-feature
  margin-bottom 10px

.top-feature-margin
  margin-top 75px
  margin-bottom 30px

.title
  font-size 2rem

.subtitle
  font-size 1rem

.download-mfi
  background-color: #000;
  // border-color: #c2bbbb;
  color #fff
  width: 250px;
  padding: 10px 0px;
  box-shadow: 0 0 5px -3px #000;
  border none
  &.is-hovered, &:hover
    box-shadow: 0 0 12px -5px #000;
    border none

.download-main
  background: #fff;
  border-color: #aeaeae;
  margin-left: 10px;

.img-miner-container
  width 290px
.img-miner
  width: 290px;
  margin: 20px 0px;

.mt-30
  margin-top 30px

.changelog-current
  background-color #f4fff7
  font-weight 400
  padding 10px 5px


.title-desc
  text-align left
  line-height 45px
  span
    font-size 2.1rem
  .title
    font-weight 600

.new-feature-li
  list-style: circle;
  margin-left: 16px;
  font-size: 12px;
  color: #829286;
  &.bold
    font-weight 600
.changelog-download-version
  width auto
  margin-right 10px

.changelog-version
  padding: 10px 0px;
  font-size: 13px;
  font-weight: 700;

.changelog-detail-list
  li
    list-style: circle;
    margin-left: 16px;
    font-size: 12px;
    color: #292929;

.size-current
  margin-left 5px
  &.mfi
    font-size 11px
  &.main
    font-size 10px

.tile
  .title
    font-size 1.25rem

html.dark, body.dark
  .title
    color #fff
  .subtitle
    color #fff
  .feature-helvetica
    color: #fff;
  .download-info
    .button.download-main
      background transparent
    .download-mfi
      background: #fff;
      border-color: #aeaeae;
      color #000
  .changelog-detail-list
    li
      color: #fff;
      strong
        color: #fff;
  .changelog-current
    color #fff
    background transparent
    li
      color #fff
  .changelog-download-version
    color #000
  .articles
    a, span
      color: #fff;
    .article-mini
      .article-inner
        &:hover
          border solid 1px #fff
  .tile
    background-color transparent
    color #fff
    .is-child
      box-shadow: 0 2px 3px #ccc, 0 0 0 1px #ccc;
  .pink
    color #fa5dfa
.mb-18
  margin-bottom 18px
   
.articles
  .article-mini
    cursor pointer
    color #4a4a4a
    padding 5px 0px
    width 100%
    display block
    .article-inner
      border-radius 5px
      border 1px solid #ccc
      padding: 7px 10px 5px 10px;
      display flex
      align-items center
      &:hover
        border solid 1px #8e8e8e
    .article-title
      flex 1
      span
        font-weight 400
    .article-content
      font-size: 12px;
      text-align: justify;
    .article-bottom
      font-size 13px

@media screen and (max-width: 864px)
  .download-files
    display flex
    .download-mfi
      flex 1


@media screen and (max-width: 768px)
  .changelog-issues-column
    display flex
    flex-direction column-reverse
  .download-files
    justify-content center
    .download-mfi
      flex initial

@media screen and (max-width: 460px)
  .download-files
    display flex
    flex-direction column
    .download-mfi
      width 100%
      margin-left 0px
    .download-main
      margin-left 0

</style>



// WEBPACK FOOTER //
// View_Download_Miner.vue?05d07d72